import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import tpl from './tpl';
import tplMobile from './tplMobile.js';
import { findNodeByClass, appendHtml } from '../util/domHelper';
import { miloCore } from '@tencent/milo-core';
import './style.css';
var isMobile = miloCore.platform.isMobile();

var AlertDialog = /*#__PURE__*/function () {
  function AlertDialog(option) {
    _classCallCheck(this, AlertDialog);

    this.renderKey = "".concat(Math.ceil(Math.random() * 10000), "_").concat(new Date().getTime());
    this.option = _objectSpread({
      message: '',
      type: 'info',
      title: '提示'
    }, option);
  }

  _createClass(AlertDialog, [{
    key: "alert",
    value: function alert() {
      var _ref = this.option || {},
          message = _ref.message,
          title = _ref.title,
          isHtml = _ref.isHtml,
          confirmTitle = _ref.confirmTitle,
          cancelTitle = _ref.cancelTitle,
          onConfirm = _ref.onConfirm,
          onClose = _ref.onClose,
          onCancel = _ref.onCancel;

      var alertHtml = tpl.replace(/\{message\}/g, isHtml ? message : miloCore.xss.filter(message));
      alertHtml = alertHtml.replace(/\{title\}/g, isHtml ? title : miloCore.xss.filter(title));
      var $selector = appendHtml(document.body, alertHtml, "".concat(this.renderKey, "-milo-alert"), 'milo-alert-frame');

      findNodeByClass($selector, 'btn-confirm')[0].onclick = function () {
        if ($selector) {
          $selector.parentNode.removeChild($selector);
        }

        onConfirm && onConfirm();
      };

      if (miloCore.isString(cancelTitle) && cancelTitle) {
        var $btnCancel = findNodeByClass($selector, 'btn-cancel')[0];
        $btnCancel.style.display = 'block';
        $btnCancel.innerText = cancelTitle;
      }

      if (miloCore.isString(confirmTitle) && confirmTitle) {
        findNodeByClass($selector, 'btn-confirm')[0].innerText = confirmTitle;
      }

      findNodeByClass($selector, 'btn-cancel')[0].onclick = function () {
        if ($selector) {
          $selector.parentNode.removeChild($selector);
        }

        onCancel && onCancel();
      };

      findNodeByClass($selector, 'milo-alert-close-btn')[0].onclick = function () {
        if ($selector) {
          $selector.parentNode.removeChild($selector);
        }

        onClose && onClose();
      };
    }
  }, {
    key: "alertMobile",
    value: function alertMobile() {
      var _ref2 = this.option || {},
          message = _ref2.message,
          title = _ref2.title,
          isHtml = _ref2.isHtml,
          confirmTitle = _ref2.confirmTitle,
          confirmColor = _ref2.confirmColor,
          cancelTitle = _ref2.cancelTitle,
          cancelColor = _ref2.cancelColor,
          onConfirm = _ref2.onConfirm,
          onCancel = _ref2.onCancel;

      var alertHtml = tplMobile.replace(/\{message\}/g, isHtml ? message : miloCore.xss.filter(message)).replace(/\{title\}/g, isHtml ? title : miloCore.xss.filter(title));
      alertHtml = alertHtml.replace(/\{cancelColor\}/g, cancelColor || '#000');
      alertHtml = alertHtml.replace(/\{confirmColor\}/g, confirmColor || '#0f4379');
      alertHtml = alertHtml.replace(/\{confirmTitle\}/g, (isHtml ? confirmTitle : miloCore.xss.filter(confirmTitle)) || '确定');
      alertHtml = alertHtml.replace(/\{cancelTitle\}/g, (isHtml ? cancelTitle : miloCore.xss.filter(cancelTitle)) || '取消');
      var $selector = appendHtml(document.body, alertHtml, "".concat(this.renderKey, "-milo-alert"), 'milo-alert-frame');

      if (title === '') {
        findNodeByClass($selector, 'milo-alert-header')[0].style.display = 'none';
      }

      if (miloCore.isString(cancelTitle) && cancelTitle) {
        findNodeByClass($selector, 'btn-cancel')[0].style.display = 'block';
      }

      findNodeByClass($selector, 'btn-confirm')[0].onclick = function () {
        if ($selector) {
          $selector.parentNode.removeChild($selector);
        }

        onConfirm && onConfirm();
      };

      findNodeByClass($selector, 'btn-cancel')[0].onclick = function () {
        if ($selector) {
          $selector.parentNode.removeChild($selector);
        }

        onCancel && onCancel();
      };
    }
  }]);

  return AlertDialog;
}();

export var miloAlert = function miloAlert(option) {
  var message;
  var type;
  var cancelTitle;
  var cancelColor;
  var confirmTitle;
  var confirmColor;
  var isHtml;

  if (typeof option === 'string' || typeof option === 'number') {
    message = option;
    option = {};
    type = 'info';
  } else {
    if (!option || !option.message) {
      throw 'miloAlert入参错误：请传入message';
    } else {
      message = option.message;
      type = option.type;
      cancelTitle = option.cancelTitle;
      cancelColor = option.cancelColor;
      confirmTitle = option.confirmTitle;
      confirmColor = option.confirmColor;
      isHtml = option.isHtml;
    }
  }

  var dialog = new AlertDialog({
    title: option.title || (isMobile ? '' : '提示'),
    message: message,
    cancelTitle: cancelTitle,
    cancelColor: cancelColor,
    confirmTitle: confirmTitle,
    confirmColor: confirmColor,
    type: type,
    isHtml: isHtml,
    onConfirm: function onConfirm() {
      option && option.onConfirm && option.onConfirm();
    },
    onClose: function onClose() {
      option && option.onClose && option.onClose();
    },
    onCancel: function onCancel() {
      option && option.onCancel && option.onCancel();
    }
  });

  if (isMobile) {
    dialog.alertMobile();
  } else {
    dialog.alert();
  }
};